import * as THREE from 'three';
import { EntityRegistry } from '../entities';
import { SystemRunner } from '../systems';

export abstract class Scene {
  abstract readonly id: string;

  readonly root: THREE.Scene;
  readonly entities: EntityRegistry;
  readonly systems: SystemRunner;

  constructor() {
    this.root = new THREE.Scene();
    this.entities = new EntityRegistry(this.root);
    this.systems = new SystemRunner();
  }

  async load(): Promise<void> {
    this.systems.init();
  }

  unload(): void {
    this.systems.dispose();
    this.entities.clear();
  }

  update(dt: number): void {
    this.systems.update(dt);
    this.entities.update(dt);
  }

  getFocusTarget(): THREE.Object3D | null {
    return null;
  }
}
